export default __webpack_public_path__ + "4018c178d7410aa687d676c765f003aa.png";